<template>
  <div class="leaderboard-table__row">
    <div
      v-if="tableItem.name"
      class="leaderboard-table__cell leaderboard-table__item-details"
    >
      <router-link
        class="leaderboard-table__link"
        :to="{ name: 'team', params: { id: tableItem.id } }"
      >
        <v-avatar size="31px" class="mr-2">
          <!-- <img v-if="tableItem.avatar" :src="tableItem.avatar" alt="Avatar" />
          <i v-else class="fas fa-user" /> -->
          {{ index + 1 }}
        </v-avatar>
        <span>{{
          tableItem.name || tableItem.first_name + " " + tableItem.last_name
        }}</span>
      </router-link>
    </div>
    <div v-else class="leaderboard-table__cell leaderboard-table__item-details" style="width:33%">
      <router-link
        class="leaderboard-table__link"
        :to="{ name: 'user', params: { id: tableItem.id } }"
      >
        <v-avatar size="31px" class="mr-2">
          {{ index + 1 }}
          <!-- <img v-if="tableItem.avatar" :src="tableItem.avatar" alt="Avatar" />
          <i v-else class="fas fa-user" /> -->
        </v-avatar>
        <span>{{
          tableItem.name || tableItem.first_name + " " + tableItem.last_name
        }}</span>
      </router-link>
    </div>
   <!-- <div class="leaderboard-table__cell leaderboard-table__total-zar">-->
      <!-- <LeaderBoardProgressbar
        v-bind:points="tableItem.zar || tableItem.nmg_miles"
        v-bind:divider="divider"
      /> -->
<!--
 <LeaderBoardProgressbar
        :points="tableItem.nmg_mile || tableItem.nmg_miles"
        :divider="divider"
      />
-->
    <div v-if="tableItem.miles_from_activities" class="leaderboard-table__cell--right">
      <LeaderBoardProgressbar
        :points="tableItem.miles_from_activities"
        :divider="divder"
      />
    </div>
    <div v-if="tableItem.miles_from_events" class="leaderboard-table__cell--right">
      <LeaderBoardProgressbar
        :points="tableItem.miles_from_events"
        :divider="divder"
      />
    </div>
    <div v-if="!tableItem.miles_from_activities || !tableItem.miles_from_events" class="leaderboard-table__cell">
      <LeaderBoardProgressbar
        :points="tableItem.nmg_mile || tableItem.nmg_miles"
        :divider="divder"
      />
    </div>

  </div>
</template>

<script>
import LeaderBoardProgressbar from "./LeaderBoardProgressbar";

export default {
  name: "LeaderBoardTableRow",
  components: {
    LeaderBoardProgressbar
  },
  props: ["tableItem", "divider", "index"]
};
</script>

<style scoped>
.leaderboard-table__row {
  display: flex;
  justify-content: space-between;
}

.leaderboard-table__cell {
  padding: 5px 0;
}

.leaderboard-table__cell--right {
  text-align: right;
  width: 33%
}

.leaderboard-table__item-details {
  /* width: 170px; */
  padding: 5px 0;
  font-size: 15px;
  font-weight: bold;
  display: flex;
  align-items: center;
}

.leaderboard-table__total-zar {
}
.leaderboard-table__link {
  color: rgb(0, 0, 0);
  text-decoration: none;
}
</style>
